// removed by extract-text-webpack-plugin
module.exports = {"orange":"#ef8d07","dark-orange":"#b55808","errorWrapper":"_3Q2E9vS5jDIcChCAWGmNPl","errorText":"_2KwY2ldNZIq_sqaEEC5puB","darkBg":"_1ZnK4-P-_qGtQ60OUmg7hK"};


//////////////////
// WEBPACK FOOTER
// ./src/uis/common/Error/Error.css
// module id = 936
// module chunks = 0